import { render, staticRenderFns } from "./fallManage.vue?vue&type=template&id=0e95d606&scoped=true"
import script from "./fallManage.vue?vue&type=script&lang=js"
export * from "./fallManage.vue?vue&type=script&lang=js"
import style0 from "./fallManage.vue?vue&type=style&index=0&id=0e95d606&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e95d606",
  null
  
)

export default component.exports